import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { preloadFor } from './app/router/lazyPages'

const rootEl = document.getElementById('root')!
;(window as unknown as { __PRERENDERED?: boolean }).__PRERENDERED = rootEl.hasChildNodes()

// Prerendered boot: React wipes #root on first commit and Suspense can hold a
// blank frame while the route chunk attaches. Keep a static clone of the
// prerendered DOM on screen until React has real content, then remove it —
// zero blank frames regardless of Suspense timing.
let ghost: HTMLElement | null = null
if (rootEl.hasChildNodes()) {
  ghost = rootEl.cloneNode(true) as HTMLElement
  ghost.id = 'rw-prerender-ghost'
  ghost.setAttribute('aria-hidden', 'true')
  rootEl.after(ghost)
}

const clearGhost = () => {
  if (!ghost) return
  if (rootEl.hasChildNodes()) {
    ghost.remove()
    ghost = null
  } else {
    requestAnimationFrame(clearGhost)
  }
}

void preloadFor(window.location.pathname).finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
  requestAnimationFrame(clearGhost)
})
